import * as React from 'react';

export const AIButton1 = (props) => (
  <svg
    width="42"
    height="43"
    viewBox="0 0 42 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_11866_32132)">
      <path
        d="M11.6568 3.55193C12.3836 3.36408 13.1801 3.93009 13.2433 4.67739C13.3786 6.1638 13.7584 7.71419 14.7797 8.85278C15.7411 9.93724 17.175 10.4549 18.577 10.6591C18.9978 10.7395 19.4596 10.6927 19.8378 10.9265C20.3308 11.2136 20.5859 11.8445 20.4268 12.3941C20.2947 12.9101 19.8197 13.3071 19.2906 13.3563C17.7386 13.5466 16.1357 14.0478 15.0184 15.1946C13.9069 16.3201 13.4287 17.9049 13.2417 19.4389C13.1727 20.0943 12.5485 20.6185 11.8922 20.5808C11.2721 20.566 10.7126 20.0591 10.6421 19.4414C10.455 17.9017 9.97353 16.3127 8.85626 15.1848C7.73489 14.0404 6.13118 13.5433 4.57833 13.3538C3.93849 13.294 3.40692 12.7099 3.41185 12.0668C3.38806 11.3908 3.96228 10.7723 4.63657 10.7411C6.164 10.6501 7.78657 10.2686 8.90712 9.15794C10.0687 8.00868 10.487 6.33771 10.6306 4.75861C10.6601 4.18767 11.0941 3.66759 11.6568 3.55193Z"
        fill="url(#paint0_linear_11866_32132)"
      />
    </g>
    <g filter="url(#filter1_d_11866_32132)">
      <path
        d="M32.4356 8.43178C33.1755 8.18405 34.0237 8.74596 34.109 9.51377C34.2231 10.2053 33.6808 10.9083 32.9893 10.9895C32.2978 11.1035 31.5849 10.5589 31.5095 9.86323C31.4118 9.24225 31.8318 8.59912 32.4356 8.43178Z"
        fill="url(#paint1_linear_11866_32132)"
      />
    </g>
    <g filter="url(#filter2_d_11866_32132)">
      <path
        d="M26.6569 12.0452C27.4133 11.8081 28.2689 12.4053 28.3132 13.1953C28.5461 15.6169 29.2057 18.1114 30.8159 19.9973C32.2342 21.6839 34.3228 22.6609 36.4474 23.1038C37.152 23.2581 37.8673 23.3532 38.5843 23.4262C39.211 23.491 39.7327 24.0612 39.7352 24.6928C39.7705 25.3523 39.2299 25.9692 38.5736 26.0307C36.668 26.2571 34.7559 26.737 33.0956 27.7279C31.8684 28.4564 30.8208 29.4834 30.0735 30.6991C29.035 32.3767 28.5387 34.3298 28.3132 36.2731C28.2656 36.8022 27.8694 37.2788 27.3526 37.4109C26.8226 37.5676 26.2123 37.3354 25.9137 36.872C25.6521 36.4881 25.689 36.0016 25.602 35.5644C25.2427 33.1929 24.356 30.8074 22.6226 29.0929C20.9262 27.3875 18.5777 26.5032 16.2373 26.1423C15.7173 26.0389 15.1086 26.0939 14.7001 25.6928C14.1267 25.1956 14.1439 24.2063 14.7362 23.7306C15.1545 23.345 15.755 23.4229 16.2759 23.3565C18.38 23.1514 20.5202 22.5296 22.169 21.1581C23.2083 20.3058 24.0032 19.1819 24.5479 17.9588C25.2181 16.4593 25.543 14.8294 25.6988 13.201C25.7374 12.6654 26.1377 12.1822 26.6569 12.0452Z"
        fill="url(#paint2_linear_11866_32132)"
      />
    </g>
    <g filter="url(#filter3_d_11866_32132)">
      <path
        d="M9.39218 32.0527C9.9664 31.9165 10.5997 32.0527 11.0599 32.4226C11.5078 32.7713 11.7883 33.3225 11.808 33.8893C11.8359 34.4701 11.5857 35.055 11.1493 35.4389C10.7317 35.8171 10.1436 35.9951 9.58659 35.9196C8.96397 35.8433 8.39468 35.4438 8.10347 34.8901C7.81882 34.361 7.79913 33.6998 8.05015 33.1552C8.29624 32.6072 8.80729 32.188 9.39218 32.0527Z"
        fill="url(#paint3_linear_11866_32132)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_11866_32132"
        x="1.41113"
        y="3.51562"
        width="21.0627"
        height="21.0669"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.341176 0 0 0 0 0.282353 0 0 0 0 0.960784 0 0 0 0.02 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_11866_32132"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_11866_32132"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_11866_32132"
        x="29.4954"
        y="8.37256"
        width="6.62891"
        height="6.63232"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.341176 0 0 0 0 0.282353 0 0 0 0 0.960784 0 0 0 0.02 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_11866_32132"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_11866_32132"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_11866_32132"
        x="12.2808"
        y="11.9927"
        width="29.4561"
        height="29.4668"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.341176 0 0 0 0 0.282353 0 0 0 0 0.960784 0 0 0 0.02 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_11866_32132"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_11866_32132"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_11866_32132"
        x="5.875"
        y="32.001"
        width="7.93506"
        height="7.93555"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.341176 0 0 0 0 0.282353 0 0 0 0 0.960784 0 0 0 0.02 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_11866_32132"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_11866_32132"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_11866_32132"
        x1="11.9425"
        y1="3.51562"
        x2="11.9425"
        y2="20.5827"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8A90FF" />
        <stop offset="1" stop-color="#B15FDA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_11866_32132"
        x1="32.8098"
        y1="8.37256"
        x2="32.8098"
        y2="11.0047"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8A90FF" />
        <stop offset="1" stop-color="#B15FDA" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_11866_32132"
        x1="27.0088"
        y1="11.9927"
        x2="27.0088"
        y2="37.4596"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8A90FF" />
        <stop offset="1" stop-color="#B15FDA" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_11866_32132"
        x1="9.84255"
        y1="32.001"
        x2="9.84255"
        y2="35.9366"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8A90FF" />
        <stop offset="1" stop-color="#B15FDA" />
      </linearGradient>
    </defs>
  </svg>
);

export default AIButton1;
